export default "__VITE_ASSET__82bf151c__"